/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/learn-css-text-visually-explained",
  title: "Learn CSS text - visually explained",
  description: `Learn CSS Text

Visually Explained📝 

Thread 🧵`,
  image: "/covers/threads/learn-css-text-visually-explained.png",
  author: "codemarch"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    code: "code",
    ol: "ol",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "codemarch",
      username: "codemarch",
      avatarUrl: "/avatars/codemarch.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/codemarch/status/1597823106709884933"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `/images/learn-css-text-visually-explained-0.png`,
      children: [_jsx(_components.p, {
        children: "Learn CSS Text"
      }), _jsx(_components.p, {
        children: "Visually Explained📝"
      }), _jsx(_components.p, {
        children: "Thread 🧵"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/learn-css-text-visually-explained-1.png`,
      children: [_jsx(_components.p, {
        children: "CSS Text"
      }), _jsx(_components.p, {
        children: "CSS has a lot of properties for formatting text."
      }), _jsx(_components.p, {
        children: "Text Color and Background Color👇"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/learn-css-text-visually-explained-2.png`,
      children: [_jsx(_components.p, {
        children: "🔹CSS Text Alignment"
      }), _jsxs(_components.p, {
        children: ["The ", _jsx(_components.code, {
          children: "text-align"
        }), " property is used to set the horizontal alignment of a text. ( left alignment is default )"]
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/learn-css-text-visually-explained-3.png`,
      children: _jsx(_components.p, {
        children: "Example of right alignment👇"
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/learn-css-text-visually-explained-4.png`,
      children: _jsx(_components.p, {
        children: "Example of justify alignment👇"
      })
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/learn-css-text-visually-explained-5.png`,
      children: [_jsx(_components.p, {
        children: "🔹Text Align Last"
      }), _jsxs(_components.p, {
        children: ["The ", _jsx(_components.code, {
          children: "text-align-last"
        }), " property specifies how to align the last line of a text."]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/learn-css-text-visually-explained-6.png`,
      children: [_jsx(_components.p, {
        children: "🔹Vertical Alignment"
      }), _jsxs(_components.p, {
        children: ["The ", _jsx(_components.code, {
          children: "vertical-align"
        }), " property sets the vertical alignment of an element."]
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/learn-css-text-visually-explained-7.png`,
      children: _jsx(_components.p, {
        children: "Example of vertical-align : middle👇"
      })
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "If you find the thread useful"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Like the thread"
        }), "\n", _jsx(_components.li, {
          children: "Retweet the first tweet."
        }), "\n", _jsx(_components.li, {
          children: "Follow me and enable notifications: ✅\n@codemarch"
        }), "\n"]
      }), _jsxs(_components.p, {
        children: ["For more look at our E-book (HTML & CSS Visual Treat!)👇\n", _jsx(_components.a, {
          href: "https://codemarch.gumroad.com/l/udhhj",
          children: "https://codemarch.gumroad.com/l/udhhj"
        })]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
